import React, { useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Container,
  Input,
  InputGroup,
  Label,
} from "reactstrap";
import * as pincodeanimetion from "./pincodeanimetion.json";
import Lottie from "react-lottie";
import { useNavigate } from "react-router-dom";

function PinCode({ onSubmit }) {
  const navigate = useNavigate();
  const [pin, setPin] = useState("");

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: pincodeanimetion.default,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const handleChange = (e) => {
    setPin(e.target.value);
  };

  const handleSubmit = () => {
    onSubmit(pin);
    setPin("");
    //navigate("/assessment/?menu=view1");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    // <Container fluid>
    //   <Card>
    //     <CardBody>
    <div className="page-content">
      <Container fluid style={{ maxWidth: "500px" }}>
        <h3 className="text-center mb-1 text-success">รหัสลับ (PIN)</h3>
        <Lottie options={defaultOptions} width={300} height={300} />
        <Label className="mt-1 text-danger">
          *กรุณาระบุรหัสลับ (PIN) 4 หลักเพื่อเข้าใช้งานระบบ
        </Label>
        <InputGroup>
          <Input
            type="password"
            value={pin}
            onKeyDown={handleKeyDown}
            onChange={handleChange}
            maxLength={4}
          ></Input>
          <Button onClick={handleSubmit} color="info">
            ยืนยัน
          </Button>
        </InputGroup>
      </Container>
    </div>
    //     </CardBody>
    //   </Card>
    // </Container>
  );
}

export default PinCode;
